import React, { Component } from 'react'
import MappingStateList from '../../../components/MappingStateList'
import { SearchOptions } from '../../../components/TableHelper'
import { MappingStateConsumer } from '../../../context/MappingStateContext'

type MappingStateProps = {
  filters: any | null,
  history: any,
  permissions: any,

  onLoad?: (searchOptions: SearchOptions) => void
}

export default class MappingState extends Component<MappingStateProps> {

  handleOnLoad = (searchOptions: SearchOptions) => {
    if (this.props.onLoad) {
      this.props.onLoad(searchOptions)
    }
  }

  render() {
    const { permissions, filters, history } = this.props

    return (
      <MappingStateConsumer>
        {({ fetching, mappingStates, pagination, requestMappingStateList }) => {

          return <MappingStateList permissions={permissions} loading={fetching} mappingStates={mappingStates} pagination={pagination} filters={filters} history={history} onLoad={this.handleOnLoad} loadMappingStates={requestMappingStateList} />
        }}
      </MappingStateConsumer>
    )
  }
}
